import Service from './Service';
import { isAfter, isEqual, parse } from 'date-fns';

/**
 * Classe utilizada para tratar regras de negócio e manipular o retorno dos webservices
 */
class PrestadorService extends Service {
  async consultarNomesTodosPrestadores () {
    let nomes = await this.getPrestadorApi().consultarNomesTodosPrestadores();

    return nomes || [];
  }
  async consultarNomesTodosPrestadoresCredenciados () {
    let nomes = await this.getPrestadorApi().consultarNomesTodosPrestadoresCredenciados();

    return nomes || [];
  }
  async consultarGruposPrestadores (nomeGrupo) {
    let grupos = [];
    const brancoAcoes = '';
    let result = await this.getPrestadorApi().consultarGruposPrestadores(nomeGrupo);
    result.map(res => {
      const { codGrupoPrestador, desGrupoPrestador, indGrupoOdontologico, qtdePrestadores } = res;
      grupos.push(Object.values({ codGrupoPrestador, desGrupoPrestador, indGrupoOdontologico, qtdePrestadores, brancoAcoes }));
    });
    return grupos || [];
  }
  async consultarNomesTodosGrupos () {
    let nomes = await this.getPrestadorApi().consultarNomesTodosGrupos();

    return nomes || [];
  }
  async consultarNomesGruposPorTipo (tipoGrupo) {
    let nomes = await this.getPrestadorApi().consultarNomesGruposPorTipo(tipoGrupo);

    return nomes || [];
  }
  async excluirGruposEmLote (grupos) {
    await this.getPrestadorApi().excluirGrupos(grupos);
  }
  async incluirGrupo (grupo) {
    let result = await this.getPrestadorApi().incluirGrupo(grupo);
    return result;
  }
  async alterarGrupo (grupo) {
    let result = await this.getPrestadorApi().alterarGrupo(grupo);
    return result;
  }
  async consultarPrestadoresVinculados (codGrupo, indGrupoOdontologico) {
    let prestadores = await this.getPrestadorApi().consultarPrestadoresVinculados(codGrupo, indGrupoOdontologico);
    return prestadores || [];
  }
  async consultarPrestadoresDesvinculados (codGrupo) {
    let prestadores = await this.getPrestadorApi().consultarPrestadoresDesvinculados(codGrupo);
    return prestadores || [];
  }
  async vincularPrestadoresEmLote (grupo) {
    let result = await this.getPrestadorApi().vincularPrestadoresEmLote(grupo);
    return result;
  }
  async desvincularPrestadoresEmLote (grupo) {
    let result = await this.getPrestadorApi().desvincularPrestadoresEmLote(grupo);
    return result;
  }
  async consultarPrestador (CPF_CNPJ, nome) {
    let prestadores = [];
    const brancoAcoes = '';
    let result = await this.getPrestadorApi().consultarPrestador(CPF_CNPJ, nome);
    let cpfCnpj = '';
    result.map(res => {
      const { codPrestador, nomPrestador, indAtivo, indPessoaFisica, numCnpj, numCPF, nomFantasiaPrestador,
        desEmail, txtSite, codBanco, codAgencia, txtContaCorrente, numProcesso, anoProcesso, numContrato, anoContrato,
        indAssociacaoPrestadores, indEmiteNFAntecipada, indGerenciaInternacao, numOrgaoExterno, nomOrgaoExterno, nomBanco,
        nomAgencia, indPrestadorCredenciado, codGrupo, nomeGrupo, indGrupoOdontologico, codVersaoTiss, txtProcessoSei} = res;
      cpfCnpj = indPessoaFisica === 'N' ? this.pad(numCnpj, 14) : this.pad(numCPF, 11);
      prestadores.push(Object.values({ codPrestador,
        nomPrestador,
        cpfCnpj,
        indAtivo,
        brancoAcoes,
        nomFantasiaPrestador,
        indPessoaFisica,
        desEmail,
        txtSite,
        codBanco,
        codAgencia,
        txtContaCorrente,
        numProcesso,
        anoProcesso,
        numContrato,
        anoContrato,
        indAssociacaoPrestadores,
        indEmiteNFAntecipada,
        indGerenciaInternacao,
        numOrgaoExterno,
        nomOrgaoExterno,
        nomBanco,
        nomAgencia,
        indPrestadorCredenciado,
        codGrupo,
        nomeGrupo,
        indGrupoOdontologico,
        codVersaoTiss,
        txtProcessoSei
      }));
    });
    return prestadores || [];
  }  
  async consultarPrestadoresSemOrgaoExterno () {
    let prestadores = [];
    const brancoAcoes = '';
    let result = await this.getPrestadorApi().consultarPrestadoresSemOrgaoExterno();
    let cpfCnpj = '';
    result.map(res => {
      const { codPrestador, nomPrestador, indPessoaFisica, numCnpj, numCPF } = res;
      cpfCnpj = indPessoaFisica === 'N' ? this.pad(numCnpj, 14) : this.pad(numCPF, 11);
      prestadores.push(Object.values({ codPrestador, nomPrestador, cpfCnpj, brancoAcoes}));
    });
    return prestadores || [];
  }
  async incluirPrestador (prestador) {
    let result = await this.getPrestadorApi().incluirPrestador(prestador);
    return result;
  }
  async alterarPrestador (prestador) {
    let result = await this.getPrestadorApi().alterarPrestador(prestador);
    return result;
  }
  async excluirPrestadoresEmLote (prestadores) {
    const result = await this.getPrestadorApi().excluirPrestadoresEmLote(prestadores);
    return result;
  }
  async vincularPrestadorOrgaoExterno (codPrestador, nomPrestador) {
    let result = await this.getPrestadorApi().vincularPrestadorOrgaoExterno(codPrestador, nomPrestador);
    return result;
  }  
  async consultarEnderecos (codPrestador) {
    let enderecos = [];
    const brancoAcoes = '';
    let result = await this.getPrestadorApi().consultarEnderecos(codPrestador);
    result.map(res => {
      const { codEndereco, codPrestador, siglaUF, cidade, bairro, desEndereco, cep, indExibirApp, numero, complemento, nomeContato } = res;
      enderecos.push(Object.values({ codEndereco, codPrestador, siglaUF, cidade, bairro, desEndereco, cep, indExibirApp, nomeContato, brancoAcoes, numero, complemento }));
    });
    return enderecos || [];
  }
  pad (str, max) {
    str = str.toString();
    return str.length < max ? this.pad('0' + str, max) : str;
  }
  async incluirEndereco (endereco) {
    let result = await this.getPrestadorApi().incluirEndereco(endereco);
    return result;
  }
  async alterarEndereco (endereco) {
    let result = await this.getPrestadorApi().alterarEndereco(endereco);
    return result;
  }
  async excluirEnderecosEmLote (enderecos) {
    const result = await this.getPrestadorApi().excluirEnderecosEmLote(enderecos);
    return result;
  }
  async consultarEspecialidadesDoPrestador (codPrestador) {
    let especialidades = await this.getPrestadorApi().consultarEspecialidadesDoPrestador(codPrestador);
    return especialidades || [];
  }
  async consultarEspecialidadesNaoVinculadas (codPrestador) {
    let especialidades = await this.getPrestadorApi().consultarEspecialidadesNaoVinculadas(codPrestador);
    return especialidades || [];
  }
  async vincularEspecialidades (codPrestador, especialidades) {
    await this.getPrestadorApi().vincularEspecialidades(codPrestador, especialidades);
  }
  async desvincularEspecialidades (codPrestador, especialidades) {
    await this.getPrestadorApi().desvincularEspecialidades(codPrestador, especialidades);
  }
  async consultarCredenciamentos (codPrestador) {
    let credenciamentos = [];
    const brancoAcoes = '';
    let result = await this.getPrestadorApi().consultarCredenciamentos(codPrestador);
    result.map(res => {
      const { codCredenciamento, codPrestador, dtaInicio, dtaFim, indPeriodoOdontologico, txtObservacao } = res;
      credenciamentos.push(Object.values({ codCredenciamento, codPrestador, dtaInicio, dtaFim, indPeriodoOdontologico, txtObservacao, brancoAcoes }));
    });
    return credenciamentos || [];
  }
  async salvarDataInicial (filter, data) {
    let result = await this.getPrestadorApi().salvarDataInicial(filter, data);
    return result;
  }
  async salvarDataFim (filter, data) {
    let result = await this.getPrestadorApi().salvarDataFim(filter, data);
    return result;
  }

  validarDataInicio (data, dataFim) {
    var dataNula = parse(new Date(null).setHours(0, 0, 0, 0));
    data = data === null ? dataNula : parse(parse(data).setHours(0, 0, 0, 0));
    dataFim = dataFim === null ? dataNula : parse(parse(dataFim).setHours(0, 0, 0, 0));

    if (isEqual(data, dataNula) || data === undefined || data.toString() === 'Invalid Date') {
      return 'A data não pode ser nula.';
    }
    if (!isEqual(data, dataNula) && !isEqual(dataFim, dataNula) && isAfter(data, dataFim)) {
      return 'A data não pode ser maior que a data fim.';
    }
    return '';
  }
  validarDataFim (data, dataInicio) {
    var dataNula = parse(new Date(null).setHours(0, 0, 0, 0));
    data = data === null || data === '' ? dataNula : parse(parse(data).setHours(0, 0, 0, 0));

    if (!isEqual(data, dataNula) && isAfter(dataInicio, data)) {
      return 'A data não pode ser menor que a data de início.';
    }
    return '';
  }
  async excluirCredenciamentosEmLote (credenciamentos) {
    const result = await this.getPrestadorApi().excluirCredenciamentosEmLote(credenciamentos);
    return result;
  }
  async incluirCredenciamento (credenciamento) {
    const result = await this.getPrestadorApi().incluirCredenciamento(credenciamento);
    return result;
  }
  async alterarCredenciamento (credenciamento) {
    const result = await this.getPrestadorApi().alterarCredenciamento(credenciamento);
    return result;
  }
  async validarCredenciamento (credenciamento, indInclusao) {
    const result = await this.getPrestadorApi().validarCredenciamento(credenciamento, indInclusao);
    return result;
  }
  async consultarTelefones (codPrestador) {
    let telefones = [];
    const brancoAcoes = '';
    let result = await this.getPrestadorApi().consultarTelefones(codPrestador);
    result.map(res => {
      const { seqTelefone, codTipoTelefone, desTipoTelefone, codPrestador, numDDD, numTelefone, indExibirApp } = res;
      telefones.push(Object.values({ seqTelefone, codTipoTelefone, desTipoTelefone, codPrestador, numDDD, numTelefone, indExibirApp, brancoAcoes }));
    });
    return telefones || [];
  }
  async incluirTelefone (telefone) {
    const result = await this.getPrestadorApi().incluirTelefone(telefone);
    return result;
  }
  async alterarTelefone (telefone) {
    const result = await this.getPrestadorApi().alterarTelefone(telefone);
    return result;
  }
  async excluirTelefonesEmLote (telefones) {
    const result = await this.getPrestadorApi().excluirTelefonesEmLote(telefones);
    return result;
  }
  async validarPrestador (prestador, indInclusao) {
    const result = await this.getPrestadorApi().validarPrestador(prestador, indInclusao);
    return result;
  }
}
export default PrestadorService;
